import { Input, Label } from "reactstrap";
import { useField } from "formik";
import classNames from "classnames";

const RadioButton = ({
  label,
  value,
  name,
  children,
  wrapperClassName,
  labelClassName,
  inputClassName,
  onChange,
  disabled,
  ...props
}) => {
  const [field] = useField({ name, value, type: "radio" });

  const handleChange = (event) => {
    if (onChange) {
      onChange(event);
    }

    field.onChange(event);
  };

  return (
    <Label
      className={classNames(
        "d-flex my-2",
        disabled && "disabled",
        wrapperClassName,
      )}
    >
      <Input
        {...field}
        {...props}
        disabled={disabled}
        onChange={handleChange}
        className={classNames("cursor-pointer flex-shrink-0", inputClassName)}
        type="radio"
        name={name}
      />
      <div className={classNames("text-regular text-body-1", labelClassName)}>
        {label || children}
      </div>
    </Label>
  );
};
export default RadioButton;
